import React, {useEffect, useState} from "react";
import {observer} from "mobx-react-lite";
import {useSitStores, useStores} from "../../../../stores";
import {Add, Check, ChevronRight, Paid} from "@mui/icons-material";
import {SitField, SitSection} from "../../../components/design/SitDesignAtoms";

export const CurrencyTable: React.FC = observer(() => {
    const {p} = useStores();
    const {ccStore, sitApi} = useSitStores();
    const [sourceCurrencyId, setSourceCurrencyId] = useState(0);
    const [targetCurrencyId, setTargetCurrencyId] = useState(0);
    const [conversionRate, setConversionRate] = useState('1');

    useEffect(() => {
        if (p.currencyCode) {
            if (sourceCurrencyId === 0) setSourceCurrencyId(ccStore.getCurrencyId(p.currencyCode));
            if (targetCurrencyId === 0) setTargetCurrencyId(ccStore.getCurrencyId(p.currencyCode));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const codeOf = (id: number) => ccStore.currencyRM.result?.find(c => c.id === id)?.code ?? '';

    const addRate = () => {
        const convRate = parseFloat(parseFloat(conversionRate).toFixed(6));
        if (sourceCurrencyId === targetCurrencyId || convRate <= 0 || convRate >= 1e12) return;
        sitApi.addConversionRate(sourceCurrencyId, targetCurrencyId, convRate)
            .then(() => ccStore.conversionRatesRM.request());
    };

    return (
        <form className="sit-settings-block" onSubmit={(event) => { event.preventDefault(); addRate(); }}>
            <SitSection icon={<Add/>} title="Add or update conversion rate" tint="a"
                        sub="Rates are used to normalise multi-currency savings into your reporting currency.">
                <div className="sit-conv-form">
                    <SitField label="From">
                        <select value={sourceCurrencyId}
                                onChange={e => setSourceCurrencyId(Number(e.target.value))}>
                            {ccStore.currencyRM.result?.map(c => <option key={c.id} value={c.id}>{c.code}</option>)}
                        </select>
                    </SitField>
                    <span className="sit-conv-eq"><ChevronRight fontSize="small"/></span>
                    <SitField label="To">
                        <select value={targetCurrencyId}
                                onChange={e => setTargetCurrencyId(Number(e.target.value))}>
                            {ccStore.currencyRM.result?.map(c => <option key={c.id} value={c.id}>{c.code}</option>)}
                        </select>
                    </SitField>
                    <SitField label="Rate">
                        <input type="number" required value={conversionRate}
                               onChange={e => setConversionRate(e.target.value)}/>
                    </SitField>
                    <button type="submit" className="ac-btn ac-btn--primary sit-conv-addbtn">
                        <Check fontSize="small"/> Save rate
                    </button>
                </div>
                <div className="sit-conv-preview">
                    1 {codeOf(sourceCurrencyId)} = <b>{(parseFloat(conversionRate) || 0).toLocaleString(undefined, {maximumFractionDigits: 6})}</b> {codeOf(targetCurrencyId)}
                </div>
            </SitSection>

            <SitSection icon={<Paid/>} title="Exchange rates" tint="b">
                <div className="sit-conv-table">
                    <table className="sit-table">
                        <thead>
                            <tr>
                                <th>Currency pair</th>
                                <th className="right">Rate</th>
                                <th>Last updated</th>
                            </tr>
                        </thead>
                        {ccStore.conversionRatesRM.result && <tbody>
                            {ccStore.conversionRatesRM.result.map((row) => (
                                <tr key={row.id}>
                                    <td>
                                        <span className="sit-conv-pair">
                                            <span className="sit-conv-cur">
                                                <span className="sit-conv-code">{row.source.code}</span>
                                                <span className="sit-conv-name">{row.source.name}</span>
                                            </span>
                                            <ChevronRight fontSize="small" className="sit-conv-arrow"/>
                                            <span className="sit-conv-cur">
                                                <span className="sit-conv-code">{row.target.code}</span>
                                                <span className="sit-conv-name">{row.target.name}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td className="right sit-conv-rate">{row.rate}</td>
                                    <td className="sit-conv-date">{new Date(row.created).toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>}
                    </table>
                </div>
            </SitSection>
        </form>
    );
});
